import React from 'react';
import { Box } from '@mui/material';
import { LOCATIONS, TARGET_AUDIENCES } from '@/constants/businessAds.constants';
import { Input, Select, Typography } from '@sm-dashboard/ui-components';

interface AdditionalInfoFormProps {
  formData: {
    location: string[];
    minPrice: number | '';
    maxPrice: number | '';
    targetAudience: string[];
    shabadHouseDiscount: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const AdditionalInfoForm: React.FC<AdditionalInfoFormProps> = ({ formData, setFormData }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h6">מידע נוסף</Typography>
      </Box>

      <Box mb={2}>
        <Select
          label="מיקום"
          multiple
          value={formData.location}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={value => setFormData((prev: any) => ({ ...prev, location: value }))}
          renderValue={selected => (selected.length > 0 ? selected.join(', ') : 'בחר לפחות מיקום אחד')}
          options={LOCATIONS.map(location => ({ value: location, label: location }))}
          required
        />
      </Box>

      <Select
        label="קהל יעד"
        multiple
        value={formData.targetAudience}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={value => setFormData((prev: any) => ({ ...prev, targetAudience: value }))}
        renderValue={selected => (selected.length > 0 ? selected.join(', ') : 'בחר לפחות קהל יעד אחד')}
        options={TARGET_AUDIENCES.map(audience => ({ value: audience, label: audience }))}
        required
      />

      <Box sx={{ mt: 2, mb: '0.35em' }}>
        <Typography variant="subtitle1">טווח מחירים</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Input
          name="minPrice"
          label="מחיר מינימום"
          type="number"
          value={formData.minPrice}
          onChange={handleChange}
          placeholder="0"
          helperText="מחיר בשקלים"
          inputProps={{ min: 0 }}
        />
        <Input
          name="maxPrice"
          label="מחיר מקסימום"
          type="number"
          value={formData.maxPrice}
          onChange={handleChange}
          placeholder="0"
          helperText="מחיר בשקלים"
          inputProps={{ min: 0 }}
        />
      </Box>
      <Input
        name="shabadHouseDiscount"
        label="הנחה מיוחדת לבתי חב״ד"
        value={formData.shabadHouseDiscount}
        onChange={handleChange}
        placeholder="לדוגמא: 15%"
      />
    </Box>
  );
};

export default AdditionalInfoForm;
